// import ManualSensorsClientFilters from '../manualSensorsClientFilters';
import { Badge, Box, Fab, Stack, Typography } from '@mui/material';
import useSearchFilters from '../../../hooks/useSearchFilters';
import useHandleFMListing from '../hooks/useHandleFMListing';
import { PageRegion } from '../../../core-components/theme/components/Screen';
import UploadFMFilesDialog from '../Dialogs/UploadFMFilesDialog';
import Button from '../../../core-components/theme/components/Button/Button';
import FMListTable from './FMListTable';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import AdditionalFilters from './Filters/AdditionalFilters';
import FMFilters from './Filters/FMFilter';
import FileTypeFilters from './Filters/FileTypeFilters';
import useIsDesktop from '../../../utilities/customHooks/useIsDesktop';
import { useParams } from 'react-router-dom';
import { FMListingQueryKeyDataInterface } from '../types';
import TuneIcon from '@mui/icons-material/Tune';
import { Neutrals, Primary } from '../../../core-components/theme/color-palette/colors';
import useMobileDialogFilters from '../hooks/useMobileDialogFilters';
import FMFMobileFilterDialog from './Filters/MobileFilterDialog';
import QueryErrorBoundary, { CentredErrorFallback } from '../../../globalComponents/ErrorBoundary';
import { useTranslation } from 'react-i18next';

const FMListing = () => {
  const { t } = useTranslation();
  const {
    searchString,
    handleSearch,
  } = useSearchFilters();
  const { assetId = '' } = useParams() as { assetId: string };
  const { showDialog, handleUploadClick, onDialogClose, handleCategorySelect, handleSubCategorySelect, selectedCategory, selectedSubCategory, fileTypeFiltersCollection, selectedFileTypes, handleFileTypeFiltersCollection, handleClearAll, activeFiltersCount } = useHandleFMListing()
  const { showMobileFiltersDialog, handleMobileFiltersDialog } = useMobileDialogFilters()
  const queryKeyData: FMListingQueryKeyDataInterface = ['fmLists', assetId, searchString, selectedCategory, selectedSubCategory, selectedFileTypes];
  const isTableAndAbove = useIsDesktop(767);
  return (
    <Stack rowGap={3} sx={{ flex: '1 0 auto' }}>
      <Stack direction={"row"} justifyContent="space-between" alignItems="center" columnGap={3}>
        <Typography variant="title">{t('plants.menu.documents', 'Documents')} </Typography>
        <Stack direction={"row"} columnGap={2} alignItems={'center'} justifyContent={'center'}>
          <Button
            variant="contained"
            onClick={handleUploadClick}
          >
            {
              isTableAndAbove &&
              <Typography variant='body1' sx={{ marginRight: '5px' }}>{t('fileManager.uploadButton', 'Upload')}</Typography>
            }
            <FileUploadOutlinedIcon sx={{ color: '#fff' }} fontSize="small" />
          </Button>
        </Stack>
      </Stack>
      <Stack rowGap={4}>
        <FMFilters
          handleSearch={handleSearch}
        >
          {
            isTableAndAbove &&
            <AdditionalFilters
              handleCategorySelect={handleCategorySelect}
              handleSubCategorySelect={handleSubCategorySelect}
              selectedCategory={selectedCategory}
              selectedSubCategory={selectedSubCategory}
              parentSxProps={{ alignItems: 'center', justifyContent: 'space-between', direction: "row", columnGap: 6, flex: 1, rowGap: 6 }}
            />
          }
        </FMFilters>
        {
          isTableAndAbove &&
          <FileTypeFilters fileTypeFiltersCollection={fileTypeFiltersCollection} handleClearAll={handleClearAll} handleFileTypeSelection={handleFileTypeFiltersCollection} />
        }
      </Stack>
      <PageRegion>
        <QueryErrorBoundary fallback={CentredErrorFallback}>
          <FMListTable searchString={searchString} selectedCategory={selectedCategory} selectedSubCategory={selectedSubCategory} selectedFileTypes={selectedFileTypes} queryKeyData={queryKeyData} />
        </QueryErrorBoundary>
      </PageRegion>
      {
        showDialog &&
        <UploadFMFilesDialog handleClose={onDialogClose} queryKeyData={queryKeyData} />
      }
      {
        !isTableAndAbove &&
        <Box sx={{ position: 'fixed', bottom: '100px', right: '23px' }} onClick={handleMobileFiltersDialog}>
          <Badge badgeContent={activeFiltersCount} sx={{ '.MuiBadge-badge': { background: Neutrals[50], color: Primary[900], border: `1px solid ${Primary[900]}`, width: 24, height: 24, borderRadius: '50%', right: 6, top: 10, zIndex: 1050 } }}>
            <Fab color="primary" aria-label={t('common.add', 'Add')}>
              <TuneIcon />
            </Fab>
          </Badge>
        </Box>
      }
      {
        showMobileFiltersDialog &&
        <FMFMobileFilterDialog
          handleCategorySelect={handleCategorySelect}
          handleSubCategorySelect={handleSubCategorySelect}
          selectedCategory={selectedCategory}
          selectedSubCategory={selectedSubCategory}
          parentSxProps={{ flex: 1, rowGap: 6 }}
          handleClose={handleMobileFiltersDialog}
        />
      }
    </Stack>
  )
};

export default FMListing;